module.exports = __webpack_public_path__ + "img/header4.db051392.jpeg";